import React from "react"

import UniversalLink from "../../../design-system/universal-link"
import PageScrollProgressBar from "../../page-scroll-progress-bar"
import TremendousLogo from "../../tremendous-logo"
import ButtonFocusToggle from "./button-focus-toggle"
import * as styles from "./index.module.scss"
import Nav from "./nav"

type Props = {
  scrollRef?: React.RefObject<HTMLElement>
}

function Header({ scrollRef }: Props) {
  return (
    <header className={styles.header}>
      <div className={styles.containerNavbar} role="banner">
        <UniversalLink to="/" aria-label="home">
          <TremendousLogo size="large" color="blue" />
        </UniversalLink>
        <ButtonFocusToggle
          containerClassName={styles.menuContainer}
          contentClassName={styles.navContainer}
          buttonClassName={styles.hamburgerMenuButtonContainer}
          emptyFocusButtonClassName={styles.hamburgerEmptyFocusButton}
          mainButtonTabIndex={-1}
          content={<Nav />}
          data-testid="mobile-nav-trigger"
        >
          <div className={styles.hamburgerMenu}>
            <div className={`${styles.hamburgerMenuLine} ${styles.top}`} />
            <div className={`${styles.hamburgerMenuLine} ${styles.middle}`} />
            <div className={`${styles.hamburgerMenuLine} ${styles.bottom}`} />
          </div>
        </ButtonFocusToggle>
      </div>
      {scrollRef && <PageScrollProgressBar scrollableElementRef={scrollRef} />}
    </header>
  )
}

export default Header
